<div class="footer-container">
  <span>{{ currentYear }} Visible Alpha, L.L.C All Rights Reserved.</span
  ><span class="footer-devider"> | </span>
  <span>Version: {{ releaseVersion }}</span
  ><span class="footer-devider"> | </span>
  <span
    ><a href="http://visiblealpha.com/privacy-policy/" target="_blank"
      >Terms of Use</a
    ></span
  ><span class="footer-devider"> | </span>
  <span><a (click)="onClickFeedback()">Feedback</a></span
  ><span class="footer-devider"> | </span>
  <span
    ><a href="https://support.visiblealpha.com" target="_blank"
      >Support</a
    ></span
  >
</div>
